import { useWizard } from "react-use-wizard";
import { IFillDataWizardSell, TKeyOfDataWizardSell, TNumberKeysOfIFillDataWizardSell } from "../..";
import EstimateStep from "../../../../../../shared/wizard/steps/estimateStep";
import sellSteps from "../sellSteps";
import { IDataFormEstimate } from "../../../../../estimate";

interface IDoNotKnowPrice_1 {
  onChange: (data: Partial<IFillDataWizardSell>) => void;
  onChangePrice: (
    data: number | number[],
    key: TNumberKeysOfIFillDataWizardSell
  ) => void;
  onReset: (key: TKeyOfDataWizardSell[]) => void;
  isNextStepDisabled: boolean;
  dataFormEstimate: Partial<IFillDataWizardSell>;
}

const DoNotKnowPrice_1 = ({
  onChange,
  onChangePrice,
  onReset,
  isNextStepDisabled,
  dataFormEstimate,
}: IDoNotKnowPrice_1) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.step_1);
    onReset(["streetId", "buildingId", "areaInSqM"]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.doNotKnowPrice.step_2);
  };

  const dataFormEstimateChecked = Boolean(
    dataFormEstimate.areaInSqM &&
      dataFormEstimate.buildingId &&
      dataFormEstimate.streetId
  );

  const handleEstimatePrice = (value: number) => {
    onChangePrice(value, "estimatedPrice");
  };

  return (
    <div>
      <EstimateStep
        mode="quiz"
        onEstimateForm={onChange}
        onEstimatePrice={handleEstimatePrice}
        onNexStep={handleNexStep}
        onPrevStep={handlePrevStep}
        isNextStepDisabled={isNextStepDisabled}
        dataFormEstimate={
          dataFormEstimateChecked
            ? (dataFormEstimate as IDataFormEstimate)
            : undefined
        }
      />
    </div>
  );
};

export default DoNotKnowPrice_1;
